(function () {

    angular.module('EventListApp')
        .factory('ApiFactory', ApiFactory);

    ApiFactory.$inject = ['$q', '$http', 'Constants', '$localstorage'];

    function ApiFactory($q, $http, Constants, $localstorage) {
        var apiFactory = {};
        apiFactory.URL = { BaseUrl: Constants.BaseUrl, ApiBaseUrl: Constants.ApiBaseUrl };
        var token;
        var cacheMode = '';

        apiFactory.SetToken = function (t) {
            token = t;
        }

        apiFactory.setCacheMode = function (mode) {
            if (mode == 'refresh')
                cacheMode = "?cache=refresh";
            else
                cacheMode = '';

        }

        apiFactory.GetEventsByParameters = function (searchModel) {
            return $http.post(Constants.LocalApiBaseUrl + 'EventListInfo', searchModel);
        };

        apiFactory.SendMessage = function (mailModel) {
            return $http.post(Constants.LocalApiBaseUrl + 'SendMessage', mailModel);
        };

        apiFactory.GetEventInfo = function (id, lang) {
            return $http.get(Constants.LocalApiBaseUrl + "GetEventInfo", { params: { projectID: id, lang: lang } });
        };

        apiFactory.GetUserCountry = function () {
            return $http.get(Constants.LocalApiBaseUrl + "GetUserCountry");
        };

        apiFactory.SetCulture = function (id, lang) {
            return $http.post(Constants.BaseUrl + "ChangeCulture", { eventid: id, culture: lang });
        };

        apiFactory.GetTickets = function (eventID, eventLang) {
            return $http.get(Constants.ApiBaseUrl + 'tickets/' + eventID + '/' + eventLang + '/get' + cacheMode, { headers: { 'API-Token': token } });
        };

        apiFactory.GetSpeakers = function (eventID, eventLang) {
            return $http.get(Constants.ApiBaseUrl + 'speakers/' + eventID + '/' + eventLang + '/general' + cacheMode, { headers: { 'API-Token': token } });
        };

        apiFactory.GetAllSpeakers = function (eventID, eventLang) {
            return $http.get(Constants.ApiBaseUrl + 'speakers/' + eventID + '/' + eventLang + '/all2' + cacheMode, { headers: { 'API-Token': token } });
        };

        apiFactory.GetKeynoteSpeakers = function (eventID, eventLang) {
            return $http.get(Constants.ApiBaseUrl + 'speakers/' + eventID + '/' + eventLang + '/keynote' + cacheMode, { headers: { 'API-Token': token } });
        };

        apiFactory.GetFeaturedSpeakers = function (eventID, eventLang) {
            return $http.get(Constants.ApiBaseUrl + 'speakers/' + eventID + '/' + eventLang + '/featured' + cacheMode, { headers: { 'API-Token': token } });
        };

        apiFactory.GetOrganizerSpeakers = function (eventID, eventLang) {
            return $http.get(Constants.ApiBaseUrl + 'speakers/' + eventID + '/' + eventLang + '/organizer' + cacheMode, { headers: { 'API-Token': token } });
        };

        apiFactory.GetCommitteeSpeakers = function (eventID, eventLang) {
            return $http.get(Constants.ApiBaseUrl + 'speakers/' + eventID + '/' + eventLang + '/committee' + cacheMode, { headers: { 'API-Token': token } });
        };

        apiFactory.GetExhibitors = function (eventID, eventLang) {
            return $http.get(Constants.ApiBaseUrl + 'exhibitors/' + eventID + '/' + eventLang + '/get' + cacheMode, { headers: { 'API-Token': token } });
        };

        apiFactory.GetAllExhibitors = function (eventID, eventLang) {
            return $http.get(Constants.ApiBaseUrl + 'exhibitors/' + eventID + '/' + eventLang + '/all' + cacheMode, { headers: { 'API-Token': token } });
        };

        apiFactory.GetSponsors = function (eventID, eventLang) {
            return $http.get(Constants.ApiBaseUrl + 'exhibitors/' + eventID + '/' + eventLang + '/sponsors' + cacheMode, { headers: { 'API-Token': token } });
        };

        apiFactory.GetParticipatingCompanies = function (eventID, eventLang) {
            return $http.get(Constants.ApiBaseUrl + 'exhibitors/' + eventID + '/' + eventLang + '/participants' + cacheMode, { headers: { 'API-Token': token } });
        };

        apiFactory.GetGalleryImages = function (eventID) {
            return $http.get(Constants.ApiBaseUrl + 'images/' + eventID + '/gallery' + cacheMode, { headers: { 'API-Token': token } });
        };

        apiFactory.GetTopics = function (eventID, eventLang) {
            return $http.get(Constants.ApiBaseUrl + 'agenda/' + eventID + '/' + eventLang + '/topics' + cacheMode, { headers: { 'API-Token': token } });
        }

        apiFactory.GetEventNewsApi = function (eventID, eventLang) {
            return $http.get(Constants.ApiBaseUrl + 'news/' + eventID + '/' + eventLang + '/get' + cacheMode, { headers: { 'API-Token': token } });
        };

        apiFactory.GetTestimonials = function (eventID, eventLang) {
            return $http.get(Constants.ApiBaseUrl + 'news/' + eventID + '/' + eventLang + '/testimonials' + cacheMode, { headers: { 'API-Token': token } });
        };

        apiFactory.GetFeaturedStories = function (eventID, eventLang) {
            return $http.get(Constants.ApiBaseUrl + 'news/' + eventID + '/' + eventLang + '/featured' + cacheMode, { headers: { 'API-Token': token } });
        };

        apiFactory.GetFeaturedStats = function (eventID, eventLang) {
            return $http.get(Constants.ApiBaseUrl + 'states/' + eventID + '/' + eventLang + '/featured' + cacheMode, { headers: { 'API-Token': token } });
        };

        apiFactory.GetFeaturedLinks = function (eventID, eventLang) {
            return $http.get(Constants.ApiBaseUrl + 'links/' + eventID + '/' + eventLang + '/featured' + cacheMode, { headers: { 'API-Token': token } });
        }

        apiFactory.GetContactUSLinks = function (eventID, currentPageID) {
            return $http.get(Constants.ApiBaseUrl + 'links/' + eventID + '/' + currentPageID + '/contactus' + cacheMode, { headers: { 'API-Token': token } });
        }

        apiFactory.GetSocialLinks = function (eventID) {
            return $http.get(Constants.ApiBaseUrl + 'links/' + eventID + '/social' + cacheMode, { headers: { 'API-Token': token } });
        }

        apiFactory.GetFAQ = function (eventID, eventLang) {
            return $http.get(Constants.ApiBaseUrl + 'faq/' + eventID + '/' + eventLang + '/get' + cacheMode, { headers: { 'API-Token': token } });
        }

        apiFactory.GetVenueMaps = function (eventID, eventLang) {
            return $http.get(Constants.ApiBaseUrl + 'venues/' + eventID + '/' + eventLang + '/maps' + cacheMode, { headers: { 'API-Token': token } });
        }

        apiFactory.GetUsersCountries = function (eventID, eventLang) {
            return $http.get(Constants.ApiBaseUrl + 'Participants/' + eventID + '/UsersCountries', { headers: { 'API-Token': token } });
        }


        apiFactory.GetExhibitorTags = function (projectID, lang) {
            var deferred = $q.defer();
            let key = "exhibitors_tags" + projectID + "_" + lang;
            var tags = $localstorage.Get(key) || [];
            if (tags.length) {
                deferred.resolve(tags);
            }
            else {
                $http.get(Constants.ApiBaseUrl + 'exhibitors/' + projectID + "/" + lang + "/tags", { headers: { 'API-Token': token } })
                    .then(function (response) {
                        let tags = response.data;
                        $localstorage.Save(key, tags);
                        deferred.resolve(tags);
                    })
            }

            return deferred.promise;
        }

        apiFactory.GetExhibitorTimeslots = function (projectID, eventCode, exhibitorID, participantID) {
            return $http.get(Constants.LocalApiBaseUrl + "GetExhibitorTimeslots", { params: { projectID: projectID, eventCode: eventCode, exhibitorID: exhibitorID, participantID: participantID } })
        }

        apiFactory.ScheduleMeeting = function (model) {
            return $http.post(Constants.LocalApiBaseUrl + "ScheduleMeeting", model)
        }

        apiFactory.CheckLogin = function (request) {
            return $http.post(Constants.LocalApiBaseUrl + "CheckLogin", request)
        }

        apiFactory.VerifyCode = function (request) {
            return $http.post(Constants.LocalApiBaseUrl + "VerifyCode", request)
        }

        return apiFactory;

    };

})();